import React, { useEffect } from "react";
import styles from "./scanVideoViewer.module.scss";
import { useGlobalContext } from "./ScanViewerContext";

declare global {
  interface MediaDeviceInfo {
    getCapabilities(): MediaTrackCapabilities;
  }
}

type Props = {
  isMobile: boolean;
  isVideoPortrait: boolean;
};

const ScanVideoViewer = ({ isMobile, isVideoPortrait }: Props) => {
  const { videoRef, stateMachineState, fullScreen } = useGlobalContext();

  const showFlash = stateMachineState.context.photoScanning;

  return (
    <>
      <video
        data-cy="cardscanVideo"
        ref={videoRef}
        className={`${styles.videoBackground} ${
          isMobile ? styles.mobile : styles.fullScreen
        } ${isVideoPortrait ? styles.portraitView : ""}`}
        id="frame"
        muted
        playsInline
        autoPlay
      ></video>
      {showFlash && (
        <div
          data-cy="captureFlash"
          className={`${styles.captureFlash} ${
            !fullScreen ? styles.embedded : ""
          }`}
        ></div>
      )}
    </>
  );
};

export default ScanVideoViewer;
